import convertRangeToRangyRange from './convertRangeToRangyRange';

export default (range: Range): string => {
  if (!range) {
    return '';
  }
  return convertRangeToRangyRange(range).toHtml();
};
